import React from 'react';
import { Trash2, X } from 'lucide-react';
import { Button } from '../ui/button';

export function OrderPanel({
  order,
  showOrderPanel,
  onClose,
  removeItemFromOrder,
  updateItemQuantity,
  calculateOrderTotal,
  setShowPaymentModal,   // ✅ ahora recibimos setShowPaymentModal
}) {
  const handlePaymentClick = () => {
    console.log('🟢 Procesar Pago desde OrderPanel: abriendo modal de pago');
    setShowPaymentModal(true);
  };

  return (
    <div
      className={`fixed inset-y-0 right-0 w-full md:w-96 bg-white shadow-xl transform transition-transform duration-300 ease-in-out z-50 ${
        showOrderPanel ? 'translate-x-0' : 'translate-x-full md:translate-x-0'
      }`}
    >
      <div className="h-full flex flex-col">
        <div className="sticky top-0 p-4 border-b flex justify-between items-center bg-white shadow-sm z-10">
          <div>
            <h2 className="text-lg font-semibold">
              {order.type === 'table' ? 'Mesa' : 'Cliente'}: {order.name}
            </h2>
            <p className="text-sm text-gray-500">
              {order.items.length} {order.items.length === 1 ? 'producto' : 'productos'}
            </p>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            className="md:hidden hover:bg-gray-100"
          >
            <X size={24} />
          </Button>
        </div>

        <div className="flex-1 overflow-y-auto">
          {order.items.length === 0 ? (
            <div className="h-full flex items-center justify-center">
              <p className="text-gray-500">No hay productos en la orden</p>
            </div>
          ) : (
            <div className="p-4 space-y-4">
              {order.items.map((item) => (
                <div
                  key={item.id}
                  className="bg-white rounded-lg border p-4 shadow-sm"
                >
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="font-medium">{item.productName}</h3>
                    <Button
                      size="sm"
                      variant="ghost"
                      className="text-red-600 hover:text-red-700 hover:bg-red-50"
                      onClick={() => removeItemFromOrder(item)}
                    >
                      <Trash2 size={16} />
                    </Button>
                  </div>
                  <div className="flex items-center justify-between">
                    <p className="text-sm text-gray-500">
                      ${(item.price * item.quantity).toFixed(2)}
                    </p>
                    <div className="flex items-center gap-3">
                      <Button
                        size="sm"
                        variant="outline"
                        className="h-8 w-8 p-0"
                        onClick={() => updateItemQuantity(item, item.quantity - 1)}
                      >
                        -
                      </Button>
                      <span className="w-8 text-center font-medium">{item.quantity}</span>
                      <Button
                        size="sm"
                        variant="outline"
                        className="h-8 w-8 p-0"
                        onClick={() => updateItemQuantity(item, item.quantity + 1)}
                      >
                        +
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="sticky bottom-0 p-4 border-t bg-white shadow-sm">
          <div className="flex justify-between items-center mb-4">
            <span className="text-lg font-semibold">Total:</span>
            <span className="text-xl font-bold text-blue-600">
              ${calculateOrderTotal(order).toFixed(2)}
            </span>
          </div>
          <Button
            className="w-full h-12 text-lg font-medium"
            disabled={order.items.length === 0}
            onClick={handlePaymentClick}  // ✅ ahora usamos nuestra función
          >
            Procesar Pago
          </Button>
        </div>
      </div>
    </div>
  );
}
